import type { EventIdentity } from "@/entities/data-model";
import type { EventFieldsGroup, EventFieldset } from "@/entities/form-metadata";
import { getRowEventIdentities } from "@/entities/form-metadata";

/** Row N binds instance N of every identity the row's fields name; the first named identity is the deterministic pick. */
export const getRowPrimaryIdentity = (fieldset: Pick<EventFieldset, "fields">): EventIdentity | undefined =>
    getRowEventIdentities(fieldset)[0];

export type BindableEventFieldset = EventFieldset & { primaryIdentity: EventIdentity };

export type BindableEventFieldsGroup = Omit<EventFieldsGroup, "fieldsets"> & { fieldsets: BindableEventFieldset[] };

export const toBindableFieldsets = (fieldsets: EventFieldset[]): BindableEventFieldset[] =>
    fieldsets.flatMap((fieldset) => {
        const primaryIdentity = getRowPrimaryIdentity(fieldset);
        return primaryIdentity ? [{ ...fieldset, primaryIdentity }] : [];
    });
